module.exports = __webpack_public_path__ + "assets/img/img303.95b70fce.png";